export default class InvestRuntimeStationData {
    constructor(id) {
        this.id           = id;
        this.locoBrigades = 0;
        this.brigades     = 0;
        this.loco         = 0;
        this.electro      = 0;
    }
}